export default __webpack_public_path__ + "static/media/personality-small-continue.da1b0bdb.svg";